// export const STRAPI_DEV_URL = "http://localhost:1337/api/";
export const STRAPI_DEV_URL = "https://dev-strapi.casimbagaming.com/api/";
export const STRAPI_PROD_URL = "https://strapi.casimbagaming.com/api/";
